module.exports = __webpack_public_path__ + "static/media/felix_icon.d535d41d.jpg";